import {
  Container,
  HeaderItem,
  Items,
} from './Header.styles.js';
import styles from '../../../../styles/Home.module.css';
import { Link } from "react-scroll";
import { useEffect, useState } from 'react';

export default function Header() {
  const [isScroll, setIsScroll] = useState('');

  const handleScroll = () => {
    if (window.pageYOffset > 0) {
      setIsScroll('fixed');
    } else {
      setIsScroll('');
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
  }, []);

  return (
    <>
      <Container className={`${isScroll}`}>
        <img src="images/logo.svg" alt="Logo Infovist" />
        <Items className={styles.hiddeOnMobile}>
          <HeaderItem className={styles.headerMenuItem}>
            <Link
              duration={300}
              to="operation"
              smooth
            >
              Como funciona
            </Link>
          </HeaderItem>
          <HeaderItem className={styles.headerMenuItem}>
            <Link
              duration={300}
              to="benefits"
              smooth
            >
              Benefícios
            </Link>
          </HeaderItem>
          <HeaderItem className={styles.headerMenuItem}>
            <Link
              duration={300}
              to="banner"
              smooth
            >
              Contratar
            </Link>
          </HeaderItem>
          <HeaderItem className={styles.headerMenuItem}>
            <Link
              duration={300}
              to="questions"
              smooth
            >
              Perguntas Frequentes
            </Link>
          </HeaderItem>
        </Items>
      </Container>
    </>
  );
}